import { downgrade as downgradeWorkspaces } from "@features/workspaces";
import { downgrade as downgradeSimpleReport } from "@features/simple-report";

export function downgradeModules() {
    downgradeWorkspaces();
    downgradeSimpleReport();
}
